import React from 'react';
import c from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import UserLink from '../../../User/Link';
import JoinGroupButton from '../../../JoinGroupButton';
import s from './GroupDetail.scss';

export interface Props {
  group?: PapiUser;
  className?: string;
}

const GroupDetail: React.FC<Props> = ({ group, className }) => {
  if (!group) {
    return null;
  }
  return (
    <div className={c(className)}>
      <UserLink
        className={s['username']}
        usernameClassName={s['username-inner']}
        withTooltip
        user={group}
      />
      <JoinGroupButton group={group} />
    </div>
  );
};
GroupDetail.displayName = 'GroupDetail';

export default GroupDetail;
